

export class StringUtil {
    /**
     * currency formatter
     *
     * @param value 
     * @param options 
     * @returns 
     */
    public static toCurrency(value: number, options: { round?: boolean, fractionDigits?: number } = { round: true, fractionDigits: 0 }): string {
        const roundedValue = !options?.fractionDigits ? Math.floor((value ?? 0) + (options?.round ? .5 : 0)) : value;
        return '$ ' + roundedValue.toLocaleString('en-US', { style: 'decimal', currency: 'USD', minimumFractionDigits: options?.fractionDigits ?? 0, maximumFractionDigits: options?.fractionDigits ?? 0 });
    }

    /**
     * number
     *
     * @param value 
     * @param options 
     * @returns 
     */
    public static toNumber(value: number, options: { round?: boolean, fractionDigits?: number } = { round: true, fractionDigits: 0 }): string {
        const roundedValue = !options?.fractionDigits ? Math.floor((value ?? 0) + (options?.round ? .5 : 0)) : value;
        return roundedValue.toLocaleString('en-US', { style: 'decimal', currency: 'USD', minimumFractionDigits: options?.fractionDigits ?? 0, maximumFractionDigits: options?.fractionDigits ?? 0 });
    }

    /**
     * 
     * @param num 
     * @returns 
     */
    public static parseAndFormatNumber(num: string): string {
        const temp = Number(num);
        if (isNaN(temp))
          return num;
        return temp.toFixed(2);
      }
}